<div class="style-box">
  <div
    class="style-box_icon"
    (click)="onClose()">
    <fa-icon [icon]="['fal', 'times']"></fa-icon>
  </div>
  <div class="style-box_title">Import new citation style</div>
  <scs-file-uploader
    [maxSizeInKilobytes]="80"
    [allowedFileExtensions]="'csl,xml'"
    (onFileUploaded)="addCustomStyle($event)">
  </scs-file-uploader>

  <div *ngIf="customStyles.length">
    <div class="style-box_title">Uploaded styles</div>
    <div class="style-box_content">
      <div 
        *ngFor="let style of customStyles"
        class="style-box_list">
        <div>
          {{ style?.title }}
        </div>
        <fa-icon 
          class="style-box_list-icon"
          [icon]="['fal', 'times']" 
          (click)="removeCustomStyle(style?.id)">
        </fa-icon>
      </div>
    </div>
  </div>

  <div class="style-box_title">Create new custom style</div>
  <div class="style-box_content">
    Note: This opens the <a href="https://citationstyles.org" target="_blank">citationstyles.org</a> visual editor in your web browser. 
    Create or edit styles in the editor, save the .csl file and import it here to use it in your document.
  </div>
  <div
    class="button-primary button-primary--sm uppercase"
    (click)="onOpenStyleEditor()">
    Create/edit styles
  </div>
</div>